// NOTE: Make sure you add any ENV variables you add here to app/views/layouts/shared/_env.html.erb
export interface Constants {
  // offer codes
  DEFAULT_ANNUAL_OFFER_CODE: string;
  DEFAULT_MONTHLY_OFFER_CODE: string;
  DEFAULT_PRO_OFFER_CODE: string;
  DEFAULT_YP_OFFER_CODE: string;
  ANNUAL_REFERRAL_OFFER_CODE: string;
  PROFILE_MODAL_OFFER_CODE: string;
  NOW_ANNUAL_OFFER_CODE: string;
  NOW_MONTHLY_OFFER_CODE: string;
  NOW_YP_OFFER_CODE: string;
  NOW_PRO_OFFER_CODE: string;
  // prices
  DEFAULT_ANNUAL_PRICE: number;
  DEFAULT_MONTHLY_PRICE: number;
  DEFAULT_PRO_PRICE: number;
  DEFAULT_YOUNG_PROFESSIONAL_PRICE: number;
  DISCOUNTED_PRO_PRICE: number;
  DISCOUNTED_REFERRAL_PRICE: number;
  // plans
  PLAN_TYPE_ANNUAL: string;
  PLAN_TYPE_MONTHLY: string;
  // Group Subscriptions
  GROUP_SUBSCRIPTION_TEAM: 'Team Subscription';
  GROUP_SUBSCRIPTION_GIFT: 'Gift Subscription';
  // Access Levels
  ACCESS_PRO: number;
  ACCESS_ANNUAL: number;
}

// offer codes
export const DEFAULT_ANNUAL_OFFER_CODE = window?.constants?.DEFAULT_ANNUAL_OFFER_CODE;
export const DEFAULT_MONTHLY_OFFER_CODE = window?.constants?.DEFAULT_MONTHLY_OFFER_CODE;
export const DEFAULT_PRO_OFFER_CODE = window?.constants?.DEFAULT_PRO_OFFER_CODE;
export const DEFAULT_YP_OFFER_CODE = window?.constants?.DEFAULT_YP_OFFER_CODE;
export const ANNUAL_REFERRAL_OFFER_CODE = window?.constants?.ANNUAL_REFERRAL_OFFER_CODE;
export const PROFILE_MODAL_OFFER_CODE = window?.constants?.PROFILE_MODAL_OFFER_CODE;
export const NOW_ANNUAL_OFFER_CODE = window?.constants?.NOW_ANNUAL_OFFER_CODE;
export const NOW_MONTHLY_OFFER_CODE = window?.constants?.NOW_MONTHLY_OFFER_CODE;
export const NOW_YP_OFFER_CODE = window?.constants?.NOW_YP_OFFER_CODE;
export const NOW_PRO_OFFER_CODE = window?.constants?.NOW_PRO_OFFER_CODE;
// prices
export const DEFAULT_ANNUAL_PRICE = window?.constants?.DEFAULT_ANNUAL_PRICE;
export const DEFAULT_MONTHLY_PRICE = window?.constants?.DEFAULT_MONTHLY_PRICE;
export const DEFAULT_PRO_PRICE = window?.constants?.DEFAULT_PRO_PRICE;
export const DEFAULT_YOUNG_PROFESSIONAL_PRICE = window?.constants?.DEFAULT_YOUNG_PROFESSIONAL_PRICE;
export const DISCOUNTED_PRO_PRICE = window?.constants?.DISCOUNTED_PRO_PRICE;
export const DISCOUNTED_REFERRAL_PRICE = window?.constants?.DISCOUNTED_REFERRAL_PRICE;
// plans
export const PLAN_TYPE_ANNUAL = window?.constants?.PLAN_TYPE_ANNUAL;
export const PLAN_TYPE_MONTHLY = window?.constants?.PLAN_TYPE_MONTHLY;
// Group Subscriptions
export const GROUP_SUBSCRIPTION_TEAM = window?.constants?.GROUP_SUBSCRIPTION_TEAM;
export const GROUP_SUBSCRIPTION_GIFT = window?.constants?.GROUP_SUBSCRIPTION_GIFT;
// Access Levels
export const ACCESS_PRO = window?.constants?.ACCESS_PRO;
export const ACCESS_ANNUAL = window?.constants?.ACCESS_ANNUAL;
